import { Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setAnchorEl } from '../../redux/features/popoverSlice';
import _ from 'lodash';
import { PAGE_ALLERGY } from '../../constants/pages/pageConstants';
import { SECTION_NOTIFICATIONS } from '../../constants/sections/sectionConstants';
import { useEffect, useState } from 'react';

const NVPopover = props => {
  const reduxDispatch = useDispatch();

  const anchorEl = useSelector(state => {
    return state?.popover?.anchorEl;
  });

  const Template = useSelector(state => state?.popover?.template);
  const fromState = useSelector(state => state?.popover?.from);
  const popoverStateOptionsList = useSelector(state => {
    return state?.popover?.optionsList;
  });

  // const notificationsList = useSelector(
  //   state => state?.popover?.notificationsList
  // );
  // console.log(`notificationsList`, notificationsList);

  let optionsList = [];
  if (fromState === PAGE_ALLERGY) {
    optionsList = popoverStateOptionsList;
  }

  // if (fromState === SECTION_NOTIFICATIONS) {
  //   optionsList = notificationsList;
  // }

  const open = Boolean(anchorEl);

  const handleOnClose = () => {
    reduxDispatch(setAnchorEl(null));
  };

  return (
    <Popover
      sx={{
        '& .MuiPopover-paper': {
          maxHeight: `50vh`,
          overflowY: 'auto',
        },
      }}
      anchorEl={anchorEl}
      onClose={handleOnClose}
      open={open}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {!_.isNull(Template) ? (
        <Template optionsList={optionsList} />
      ) : (
        <>isEmpty</>
      )}
    </Popover>
  );
};

export default NVPopover;
